import { consts } from '@ps/web-poker-utils';

import type { Language } from '../types';

import { BASE_POKER_STR, TILE_IMAGE_FORMAT, getRailCdnBaseUrl } from './game';

export default function imagePpp(
  language: Language,
  hspFlagsMap: Record<string, unknown> = {},
  isPPPRevampNeymar: boolean,
  isThemeV2Image?: boolean
) {
  // generic version
  let fileName = 'grand_tour_';
  const railCdnBaseUrl = getRailCdnBaseUrl(!!isThemeV2Image);

  if (isPPPRevampNeymar) {
    fileName = 'kickoff';

    if (hspFlagsMap[consts.hspFlags.PPP_Neymar]) {
      fileName += '_neymar';
    }
  }

  if (fileName === 'grand_tour_') {
    // @note: Grand Tour assets are differ for some countries
    if (['fr', 'es'].indexOf(language) >= 0) {
      fileName += language;
    } else {
      fileName += 'en';
    }
  }

  return `${railCdnBaseUrl}${BASE_POKER_STR}${fileName}${TILE_IMAGE_FORMAT}`;
}
